// 207B §5 — THE FIRM SETTINGS' ONE SAVE QUEUE, for the whole page: every field
// of the Settings panes saves through it (src/App.tsx `saveFirmSettings`), and
// what is on the wire or waiting is what the user typed after the last answer
// left — so a row from the server is laid UNDER it, both where App takes a row
// (`takeFirmSettings`) and where the pane copies App's row over its own
// (SettingsView's `fsLocal` effect, which runs after a render: a key typed
// between that render and the effect is already in the queue when the effect's
// update runs — measured in WebKit, where App's merge alone lost it).
// One queue per page, as `tempId`'s counter is one per page (src/lib/tempId.ts).
import { updateFirmSettings } from "../api";
import { createSaveQueue } from "./saveQueue.mjs";

type FirmPatch = Record<string, unknown>;

export const firmSettingsSaves = createSaveQueue(
  (p: FirmPatch) => updateFirmSettings(p) as Promise<FirmPatch | null>,
  (waiting: FirmPatch | null, next: FirmPatch) => ({ ...(waiting ?? {}), ...next }),
);

/** What was typed and has not been answered yet: the patch on the wire, then the one waiting. */
export const firmSettingsTyped = (): FirmPatch => ({
  ...(firmSettingsSaves.inflight() ?? {}),
  ...(firmSettingsSaves.waiting() ?? {}),
});
